import React from 'react';
import { styled } from '@mui/material';
import clsx from 'clsx';

const PREFIX = 'MobileLayout';

const classes = {
    phone: `${PREFIX}-phone`,
    content: `${PREFIX}-content`
};

const StyledDiv = styled('div', {
    shouldForwardProp: propName => propName === 'className' || propName === 'children'
})<{ scale?: number }>(({ theme, scale }) => ({
    borderRadius: theme.spacing(2),
    width: scale * 375,
    height: scale * 785,
    margin: scale * 16,
    border: '8px #eae8e8 solid',
    borderTopWidth: scale * 50,
    borderBottomWidth: scale * 50,
    boxShadow: theme.shadows[3],
    position: 'relative',
    '&:after': {
        content: 'no-close-quote',
        display: 'block',
        width: scale * 40,
        height: scale * 5,
        position: 'absolute',
        top: scale * -25,
        left: '50%',
        transform: 'translateX(-50%)',
        background: '#333',
        borderRadius: scale * 5
    },
    [`& .${classes.content}`]: {
        position: 'relative',
        zIndex: 0,
        marginRight: 2,
        height: '100%',
        overflowX: 'hidden',
        overflowY: 'scroll',
        width: '100%'
    }
}));

export interface MobileLayoutProps {
    className?: string;
    scale?: number;
    children?: React.ReactNode;
}

export const MobileLayout: React.FC<MobileLayoutProps> = props => {
    const { children, scale = 0.6, ...rest } = props;
    return (
        <StyledDiv scale={scale} {...rest} className={rest.className}>
            <div className={clsx(classes.content, 'hidden-scroll')}>{children}</div>
        </StyledDiv>
    );
};
